/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CallNotificationPagedList } from '../../models/call-notification-paged-list';
import { CallNotificationSearchBody } from '../../models/call-notification-search-body';
import { CallNotificationSortFieldName } from '../../models/call-notification-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface SearchCallNotificationsByStation$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data: 
 *  * CALL_DATE : the call date 
 *  * CALL_TYPE : the call type 
 *  * CALL_STATUS : the call status 
 *  * STATION_CODE : the station code 
 *  * INTERVENANT_CODE : the intervenant code
 */
  sortFieldName?: CallNotificationSortFieldName;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search call notifications
     */
    body?: CallNotificationSearchBody
}

export function searchCallNotificationsByStation(http: HttpClient, rootUrl: string, params: SearchCallNotificationsByStation$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotificationPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchCallNotificationsByStation.PATH, 'post');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CallNotificationPagedList>;
    })
  );
}

searchCallNotificationsByStation.PATH = '/stations/{uid}/notification/call/search';
